import React, { useEffect, useMemo, useState } from "react";
// import { useTheme } from "../contexts/ThemeContext";
import AuthServiceV2 from "../services/authServiceV2";
import AppSettingsService from "../services/appSettingsService";
import { AUTH_ROLES } from "../utils/authConstants";
import QuizBanner from "../assets/Quiz_Banner.png";
import "./UserLogin.css";

const UserLogin = ({ onLogin, onForgotPassword }) => {
  // const { theme } = useTheme();

  const [credentials, setCredentials] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [bannerSrc, setBannerSrc] = useState(QuizBanner);
  const [isBannerLoading, setIsBannerLoading] = useState(true);

  const isFormValid = useMemo(() => {
    const emailOk = credentials.email.trim().length > 3;
    const passOk = credentials.password.length >= 6;
    return emailOk && passOk;
  }, [credentials]);

  useEffect(() => {
    let isMounted = true;

    const loadBanner = async () => {
      try {
        setIsBannerLoading(true);
        const result = await AppSettingsService.getLoginBanner();
        const imageUrl = result?.success ? result.data?.image_url : null;
        
        if (isMounted) {
          setBannerSrc(imageUrl ? AppSettingsService.getMediaUrl(imageUrl) : QuizBanner);
        }
      } catch {
        if (isMounted) {
          setBannerSrc(QuizBanner);
          setIsBannerLoading(false);
        }
      }
    };

    loadBanner();

    return () => {
      isMounted = false;
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    try {
      const payload = {
        email: credentials.email.trim(),
        password: credentials.password,
      };

      const result = await AuthServiceV2.userLogin(payload);

      if (result?.success) {
        onLogin(result.data, AUTH_ROLES.USER);
      } else {
        setError(result?.message || "Login failed. Please try again.");
      }
    } catch (err) {
      setError("Something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-shell">
        {/* Left Side */}
        <aside className="login-aside" aria-hidden="true">
          <div className="brand">
            <div className="brand-text">
              {/* <h2>Quiz Portal</h2>
              <p>Sign in to access your quizzes and progress.</p> */}
              <div className="brand-content">
                {isBannerLoading && (
                  <span className="brand-image-loader" aria-label="Loading banner" />
                )}
                <img
                  src={bannerSrc}
                  alt="Quiz Portal"
                  className={`brand-image ${isBannerLoading ? "is-loading" : ""}`}
                  loading="lazy"
                  decoding="async"
                  onLoad={() => setIsBannerLoading(false)}
                  onError={() => {
                    if (bannerSrc !== QuizBanner) {
                      setIsBannerLoading(true);
                      setBannerSrc(QuizBanner);
                    } else {
                      setIsBannerLoading(false);
                    }
                  }}
                />
              </div>
            </div>
          </div>
        </aside>

        {/* Right Side */}
        <main className="login-card" role="main">
          <header className="login-header">
            <h1>Interviewer Login</h1>
            <p>Welcome to the sci interview portal</p>
          </header>

          {error && (
            <div className="alert" role="alert">
              ⚠️ {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <div className="input-wrap">
                <input
                  type="email"
                  id="email"
                  autoComplete="email"
                  value={credentials.email}
                  onChange={(e) =>
                    setCredentials({ ...credentials, email: e.target.value })
                  }
                  placeholder="name@example.com"
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <div className="input-wrap input-with-button">
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  autoComplete="current-password"
                  value={credentials.password}
                  onChange={(e) =>
                    setCredentials({ ...credentials, password: e.target.value })
                  }
                  placeholder="Enter your password"
                  required
                />
                <button
                  type="button"
                  className="ghost-btn"
                  onClick={() => setShowPassword((prev) => !prev)}
                >
                  {showPassword ? "Hide" : "Show"}
                </button>
              </div>
            </div>

            {/* <div className="form-row">
              <button
                type="button"
                className="link-btn"
                onClick={() => (onForgotPassword ? onForgotPassword() : undefined)}
              >
                Forgot password?
              </button>
            </div> */}

            <button
              type="submit"
              className="primary-btn"
              disabled={!isFormValid || isLoading}
            >
              {isLoading ? (
                <span className="btn-loading">
                  <span className="spinner" />
                  Signing in...
                </span>
              ) : (
                "Sign In"
              )}
            </button>
          </form>
        </main>
      </div>
    </div>
  );
};

export default UserLogin;
